export const swipeConfigSchema = {
  type: 'object',
  properties: {
    voiceoverMarker: {
      type: 'object'
    },
    correct: {
      type: 'array',
      items: {
        type: 'number'
      }
    },
    imageSize: {
      type: 'string'
    }
  }
}
